import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import styles from "./BooleanButtons.module.scss";
import {GRID_VIEW, LIST_VIEW, TIMELINE_VIEW} from "../../constants";
import TimelineIcon from "../../icons/TimelineIcon";

const BooleanButtons = ({ trueLabel, falseLabel, myBookingsView, trueProps, falseProps, value, onChange, ...props }) => {
  const activeStyle = {
    backgroundColor: "var(--one-color-interaction-active-brand-4)",
    color: "var(--one-color-interaction-focus-brand-1)",
  };

  return (
    <div className={styles.booleanButton}>

      <button
        onClick={() => onChange(LIST_VIEW)}
        style={value === LIST_VIEW ? activeStyle : undefined}
      >
        <FormatListBulletedIcon style={{ width: 45 }} />
      </button>

      <div className={styles.verticalLine}></div>

      <button
        onClick={() => onChange(GRID_VIEW)}
        style={value === GRID_VIEW ? activeStyle : undefined}
      >
        <CalendarTodayIcon style={{ width: 45 }} />
      </button>

      {!myBookingsView && <div className={styles.verticalLine}></div>}

      {!myBookingsView &&<button
        aria-label="Timeline view"
        onClick={() => onChange(TIMELINE_VIEW)}
        style={value === TIMELINE_VIEW ? activeStyle : undefined}
      >
        <TimelineIcon style={{ width: 45 }} />
      </button>}

    </div>
  );
};

export default BooleanButtons;
